export const OPTHINES = {
  voteName: '2020project/2020shangyou_community',
  mustSearch: 'Button',
  number: {
    mustRank: false,
  },
  themeColor: {
    activeBgColor: 'rgb(187, 211, 220)',
    inactiveBgColor: 'rgb(187, 211, 220)',
  },
  areasPickerData: [
    '渝中区',
    '大渡口区',
    '江北区',
    '沙坪坝区',
    '九龙坡区',
    '南岸区',
    '北碚区',
    '渝北区',
    '巴南区',
    '两江新区',
    '其他',
    '无明显区域',
  ],
};
